<button (click)="onAddClick()" class="text-sm justify-center w-[8ch] flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
    Add
</button>
<div class="fixed inset-0 w-screen h-screen overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 p-2 z-[100]" [ngClass]="{ 'invisible' : !isVisible}">
    <div class="flex items-center justify-center pt-20">
        <div #addFriendModal class="w-[24rem] sm:w-[36rem] bg-slate-100 rounded shadow-lg flex flex-col text-base">
            <!-- Title Bar -->
            <div class="flex flex-row bg-ponder-light text-slate-50 stroke-slate-50 rounded-t shadow pr-2">
                <div class="grow font-bold p-2">Add Friend</div>
                <button (click)="onClose()" class="w-8 h-8 p-2 stroke-faded-50 hover:stroke-white hover:cursor-pointer">
                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                        <title>Close</title>
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                    </svg>
                </button>
            </div>
            <!-- Content -->
            <div class="flex flex-col bg-slate-100 p-4 text-sm rounded-b gap-2 w-full" [ngClass]="{ 'hidden' : (isAdding || addError)}">
                <div>
                    Search by username or display name:
                </div>
                <div class="w-full">
                    <input #userSearch type="text" class="rounded shadow-sm p-1 w-full bg-slate-50">
                </div>
                @if (!hasSearchedOnce) {

                } @else {
                    @if (isSearching || searchError) {
                        <loading [isLoading]="isSearching" [success]="!searchError"></loading>
                    } @else {
                        @if (searchResults?.length) {
                            <div class="flex flex-col border rounded max-h-80 bg-slate-50 overflow-y-auto">
                                @for (result of searchResults ; track result.userId) {
                                    <user-friend-add-row [userInfo]="result"></user-friend-add-row>
                                }
                            </div>
                        } @else {
                            <div class="text-slate-400">
                                No matching users found.
                            </div>
                        }
                    }
                }
            </div>
            @if (isAdding || addError) {
                <div class="p-6">
                    <loading [isLoading]="isAdding" [success]="!addError"></loading>
                </div>
            }
        </div>
    </div>
</div>